import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default class Notification extends Component {
    constructor(props) {
        super(props)

        this.state = {
            notification: {
                uuid: '',
                visible: false,
                type: '',
                description: '',
                delay: 3000,
                style_type: '',
            },
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    componentDidMount() {
        this.controlNotificationChange()
    }

    componentDidUpdate() {
        this.controlNotificationChange()
    }

    controlNotificationChange = () => {
        if (this.props.notification === undefined) return null
        let { notification } = this.props

        if (
            !notification.uuid ||
            notification.uuid === this.state.notification.uuid
        )
            return null
        this.handleNotificationChange(notification)
        this.props.changeNotificationStatus({})
    }

    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    render() {
        let { notification } = this.state
        return (
            <React.Fragment>
                {notification.visible ? (
                    <div
                        className={`data-protection__notifications data-protection__notifications_${
                            notification['style_type']
                        }`}
                    >
                        <FontAwesomeIcon
                            className="profile__icon profile__icon_notification"
                            icon={'info'}
                        />
                        <p>{`${
                            this.translation[
                                this.state.notification.description
                            ]
                        }`}</p>
                    </div>
                ) : null}
            </React.Fragment>
        )
    }

    handleNotificationChange = options => {
        let notification = Object.assign({}, this.state.notification)

        if (options['type'] === 'unmount') {
            clearTimeout(this.timeout)
        } else if (notification['visible'] && options['type'] !== 'timeout') {
            clearTimeout(this.timeout)
            notification['visible'] = !notification['visible']
        }

        Object.keys(options).length &&
            Object.keys(options).forEach(item => {
                notification[item] =
                    options[item] !== 'timeout' && options[item] !== 'unmount'
                        ? options[item]
                        : ''
            })
        notification['visible'] = !notification['visible']
        notification['style_type'] = this.props.notification.type
            ? this.props.notification.type
            : ''

        this.setState({
            notification,
        })

        if (notification['visible']) {
            this.timeout = setTimeout(() => {
                this.handleNotificationChange({
                    uuid: '',
                    type: 'timeout',
                    description: '',
                })
            }, notification.delay)
        }
    }
}
